import { render, staticRenderFns } from "./EntryBulkMessage.vue?vue&type=template&id=74fbc9d6"
import script from "./EntryBulkMessage.vue?vue&type=script&lang=js"
export * from "./EntryBulkMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports